import { render } from "./HiFormValueHolder.vue?vue&type=template&id=af39a0e2"
import script from "./HiFormValueHolder.vue?vue&type=script&lang=js"
export * from "./HiFormValueHolder.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__